export enum NewsAttachmentType {
  IMAGE = 'IMAGE',

  DOCUMENT = 'DOCUMENT',
}
